import { DeletedTourBag, TourBagIronDetail } from '@/api/models';

export const createDeletedTourBagIronDetail = (bag: TourBagIronDetail): DeletedTourBag => {
  const deletedBag: DeletedTourBag = {
    tourBagDetailId: undefined,
    headWeightLocationBackLookupId: bag.headWeightLocationBackLookupId,
    headWeightLocationBackLookupName: bag.headWeightLocationBackLookupName,
    headWeightNumberBackLookupId: bag.headWeightNumberBackLookupId,
    headWeightNumberBackLookupName: bag.headWeightNumberBackLookupName,

    tourBagIronDetailId: bag.tourBagIronDetailId,
    tourBagMstrId: bag.tourBagMstrId,
    playerId: bag.playerId,
    tourId: bag.tourId,
    headTypeId: bag.headTypeId,
    itemNo: bag.itemNo,
    editSource: bag.editSource,
    playerName: bag.playerName,
    tourName: bag.tourName,
    headTypeDescription: bag.headTypeDescription,
    hand: bag.hand,
    headModelId: bag.headModelId,
    headModelName: bag.headModelName,
    shaftName: bag.shaftName,
    shaftPinstamp: bag.shaftPinstamp,
    shaftCosmetic: bag.shaftCosmetic,
    ironClubId: bag.ironClubId,
    ironClubName: bag.ironClubName,
    shaftTippingDigit: bag.shaftTippingDigit,
    shaftTippingFraction: bag.shaftTippingFraction,
    isShaftLengthFinished: bag.isShaftLengthFinished,
    shaftLengthDigit: bag.shaftLengthDigit,
    shaftLengthDigitId: bag.shaftLengthDigitId,
    shaftLengthDigitId1: bag.shaftLengthDigitId1,
    shaftLengthFraction: bag.shaftLengthFraction,
    shaftLengthFractionId: bag.shaftLengthFractionId,
    shaftLengthFractionId1: bag.shaftLengthFractionId1,
    loftDigit: bag.loftDigit,
    loftFraction: bag.loftFraction,
    loftDigitId: bag.loftDigitId,
    loftFractionId: bag.loftFractionId,
    lieDigit: bag.lieDigit,
    lieDigitId: bag.lieDigitId,
    lieFraction: bag.lieFraction,
    lieFractionId: bag.lieFractionId,
    swingWtPrefixName: bag.swingWtPrefixName,
    swingWtSuffixName: bag.swingWtSuffixName,
    swingWtPrefixId: bag.swingWtPrefixId,
    swingWtSuffixId: bag.swingWtSuffixId,
    gripType: bag.gripType,
    gripSize: bag.gripSize,
    gripTypeId: bag.gripTypeId,
    gripSizeId: bag.gripSizeId,
    tape: bag.tape,
    gripTape: bag.tape,
    rndRib: bag.rndRib,
    logo: bag.logo,
    notes: bag.notes,
    orderDetailId: bag.orderDetailId,
    tourBagMstrRowGuid: bag.tourBagMstrRowGuid,
    rowGuid: undefined,
    isActive: false,
    deletedCreateDate: new Date(),
    deletedModifyDate: new Date(),
    createDate: new Date(),
    modifyDate: new Date(),
    deletedCreateUserGuid: undefined,
    deletedModifyUserGuid: undefined,
    createUserGuid: undefined,
    modifyUserGuid: undefined,
    shaftFlexName: '',
    shaftBendName: '',
    yearName: '',
    lie: undefined,
    sightLine: '',
    neck: '',
    weights: '',
    headWeight: undefined,
    metaName: '',
    shaftBendId: undefined,
    familyId: bag.familyId,
    familyName: bag.familyName,
    familyNote: '',
    headFinishName: '',
    headFinishNote: '',
    stamping: '',
    grindDetails: '',
    ratGlue1: '',
    ratGlue2: '',
    ratGlue3: '',
    ratGlue4: '',
    ratGlue5: '',
    ratGlue6: '',
    ratGlue7: '',
    headWeightLocationLookupId: undefined,
    headWeightNumberLookupId: undefined,
    cgFlatWeightId: undefined,
    tourBagDetailRowGuid: undefined,
    tourBagIronDetailRowGuid: undefined,
    // Fill in the rest of the props even if they don't belong to irons, same as other props such as ratGlue, just to comply with API contract
    serialMstrId: -1,
    appUserName: '',
    settingName: '',
    cgFlatWeightName: '',
    headWeightLocationLookupName: '',
    headWeightNumberLookupName: '',
    loftName: '',
    measuredLoft: undefined,
    laserNo: '',
    ct: undefined,
    ctLocation: '',
    sleeve: '',
    sleeveName: '',
    yearId: undefined,
    metalId: undefined,
    loftId: undefined,
    shaftFlexId: undefined,
    settingId: undefined,
    sleeveId: undefined,
    headFinishId: undefined,
  };

  return deletedBag;
};
